import { Injectable, TemplateRef, Injector } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {DialogConfig, DialogRef} from '@angular/cdk/dialog';
import {DialogComponent, DialogData} from '../components/ui/dialog/dialog.component';
@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private overlay: Overlay, private injector: Injector) {}

  open(title: string, content: TemplateRef<any>, actions: TemplateRef<any>, overlayConfig?: OverlayConfig): DialogRef<string> {
    const overlayRef = this.createOverlay(overlayConfig);
    const dialogConfig: DialogConfig<DialogData> = {};
    const dialogRef = new DialogRef<string>(overlayRef, dialogConfig);

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: DialogRef, useValue: dialogRef },
        { provide: OverlayRef, useValue: overlayRef }
      ]
    });

    const componentPortal = new ComponentPortal(DialogComponent, null, injector);
    const componentRef = overlayRef.attach(componentPortal);

    componentRef.instance.data = { title, content, actions };

    overlayRef.backdropClick().subscribe(() => {
      dialogRef.close();
      overlayRef.dispose();
    });

    return dialogRef;
  }

  private createOverlay(overlayConfigArg? : OverlayConfig): OverlayRef {
    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    });

    const overlayConfigMerged = {
      ...overlayConfig,
      ...overlayConfigArg,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: overlayConfig.positionStrategy,
      hasBackdrop: true, // Ensure backdrop is always enabled
    };

    return this.overlay.create(overlayConfigArg ? overlayConfigMerged : overlayConfig);
  }
}
